(function () {
  'use strict';

  angular.module('sempraWebapp').service('gridUtils', gridUtilsService);

  /** @ngInject */
  function gridUtilsService($translate) {
    this.getDefaultGridSettings = function () {
      return {
        limitPerPage: 10,
        page : 1,
        order : 'id',
        translations: {
          page: $translate.instant('GRID_PAGER_PAGE'),
          rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
          of: $translate.instant('GRID_PAGER_PAGE_OF')
        }
      }
    };
  }
})();
